import { Redirect, Route, Switch } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import useMediaQuery from '@mui/material/useMediaQuery'

import { FlexContainer } from 'components/Flex'
import useAuth from 'lib/auth'
import { useDoc } from 'lib/firestore'

import AccountList from './AccountList'
import Dashboard from './Dashboard'
import MailTemplateList from './MailTemplateList'
import Menu from './Menu'
import ProductList from './ProductList'
import UserList from './UserList'

export default function Admin() {
  const { isAdmin } = useAuth()
  const isXS = useMediaQuery(({ breakpoints }) => breakpoints.only('xs'))
  const { item: count } = useDoc('shared/count')

  if (!isAdmin) {
    return <Redirect to="/" />
  }

  if (!count) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <FlexContainer row>
      {!isXS && <Menu />}
      <Switch>
        <Route path="/admin/dashboard">
          <Dashboard />
        </Route>
        <Route path="/admin/accounts">
          <AccountList count={count.account} />
        </Route>
        <Route path="/admin/users">
          <UserList count={count.admin} />
        </Route>
        <Route path="/admin/products">
          <ProductList count={count.product} />
        </Route>
        <Route path="/admin/templates">
          <MailTemplateList />
        </Route>
        <Redirect to="/admin/dashboard" />
      </Switch>
    </FlexContainer>
  )
}
